import React from 'react';

import PrimaryButton from '../../components/PrimaryButton';

function Confirmation({ history }) {
    return (
        <div className='modal'>
            <div className='modal__content'>
                <div className='modal__title'>
                    <h2>Bestätigung</h2>
                </div>
                <div className='modal__body'>
                    <p>
                        Herzlichen Glückwunsch! Ihr Vertrag wurde erfolgreich digital signiert. 
                        Die Kreditsumme in Höhe von 20.000€ wurde auf Ihrem Girokonto bereitgestellt.
                    </p>
                    <p>
                      Ihre signierten Vertragsdokumente senden wir Ihnen per Email zu.  
                    </p>
                </div>
                <div className='modal__footer'>
                    <PrimaryButton
                        title='Zurück zur Übersicht'
                        onClick={() => history.push('/dashboard?success=true')}
                    />
                </div>
            </div>
        </div>
    )
}

export default Confirmation;
